export default __webpack_public_path__ + "static/media/Icon15.2bbebe25.svg";